/* eslint-disable no-nested-ternary */
import PropTypes from 'prop-types';
import { Avatar, Box, Button, Card, IconButton, Typography } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import PhoneIcon from '@mui/icons-material/Phone';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import PanToolIcon from '@mui/icons-material/PanTool';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import PhoneCallbackIcon from '@mui/icons-material/PhoneCallback';
import PhoneMissedIcon from '@mui/icons-material/PhoneMissed';
import * as moment from 'moment';

const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' };

const CustomerCommercialComment = (props) => {
  const { createdAt, comment, source, id, handleDelete, qualification, reason, recallDate, formation1, formation2, formation3, nameFormation1, nameFormation2,
    nameFormation3, offeredFormation, nameOfferedFormation, user, customer, ...other } = props;
  let nameFormation1Transf = '';
  let nameFormation2Transf = '';
  let nameFormation3Transf = '';
  let nameOfferedFormationTransf = '';
  let formation1Transf = '';
  let formation2Transf = '';
  let formation3Transf = '';
  let offeredFormationTransf = '';
  if (nameFormation1 !== null && nameFormation1 !== undefined) {
    if (nameFormation1.length > 50) {
      nameFormation1Transf = `${nameFormation1.substring(0, 50)}...`;
    } else {
      nameFormation1Transf = nameFormation1;
    }
  }
  if (nameFormation2 !== null && nameFormation2 !== undefined) {
    if (nameFormation2.length > 50) {
      nameFormation2Transf = `${nameFormation2.substring(0, 50)}...`;
    } else {
      nameFormation2Transf = nameFormation2;
    }
  }
  if (nameFormation3 !== null && nameFormation3 !== undefined) {
    if (nameFormation3.length > 50) {
      nameFormation3Transf = `${nameFormation3.substring(0, 50)}...`;
    } else {
      nameFormation3Transf = nameFormation3;
    }
  }
  if (nameOfferedFormation !== null && nameOfferedFormation !== undefined) {
    if (nameOfferedFormation.length > 40) {
      nameOfferedFormationTransf = `${nameOfferedFormation.substring(0, 40)}...`;
    } else {
      nameOfferedFormationTransf = nameOfferedFormation;
    }
  }
  if (formation1 !== null && formation1 !== undefined) {
    if (formation1.name.length > 50) {
      formation1Transf = `${formation1.name.substring(0, 50)}...`;
    } else {
      formation1Transf = formation1.name;
    }
  }
  if (formation2 !== null && formation2 !== undefined) {
    if (formation2.name.length > 50) {
      formation2Transf = `${formation2.name.substring(0, 50)}...`;
    } else {
      formation2Transf = formation2.name;
    }
  }
  if (formation3 !== null && formation3 !== undefined) {
    if (formation3.name.length > 50) {
      formation3Transf = `${formation3.name.substring(0, 50)}...`;
    } else {
      formation3Transf = formation3.name;
    }
  }
  if (offeredFormation !== null && offeredFormation !== undefined && offeredFormation.name !== undefined) {
    if (offeredFormation.name.length > 40) {
      offeredFormationTransf = `${offeredFormation.name.substring(0, 40)}...`;
    } else {
      offeredFormationTransf = offeredFormation.name;
    }
  }

  const CreateOutlookMeetingButton = () => {

    const generateICSFileAndOpen = () => {
      if (!recallDate) {
          alert("Veuillez fournir une date de rappel valide !");
          return;
      }

      const startDate = new Date(recallDate);
      const endDate = new Date(startDate.getTime() + 20 * 60 * 1000); // 20 min après le début

      const formatDateToICS = (date) => {
          return date.toISOString().replace(/[-:]/g, '').split('.')[0];
      };

      const { hostname } = window.location;
      const tenant = hostname.split('.')[0].toUpperCase();

      const formattedStartDate = formatDateToICS(startDate);
      const formattedEndDate = formatDateToICS(endDate);

      // NE PAS TOUCHER ! AUCUN PROBLÈME D'INDENTATION
      // NE PAS TOUCHER ! AUCUN PROBLÈME D'INDENTATION
      // NE PAS TOUCHER ! AUCUN PROBLÈME D'INDENTATION
const icsContent = `
BEGIN:VCALENDAR
VERSION:2.0
PRODID:-//Syndays//Calendrier//FR
METHOD:REQUEST
BEGIN:VEVENT
UID:${new Date().getTime()}@syndays.fr
DTSTAMP:${formattedStartDate}
DTSTART:${formattedStartDate}
DTEND:${formattedEndDate}
SUMMARY:Rendez-vous avec ${tenant}
DESCRIPTION:Rendez-vous téléphonique pour vos formations DPC.
LOCATION:Téléphone
ORGANIZER;CN=Commercial ${tenant}:MAILTO:${user.email}
ATTENDEE;CN=Professionnel de santé;RSVP=TRUE:MAILTO:${customer.apprenant.email}
BEGIN:VALARM
TRIGGER:-PT15M
ACTION:DISPLAY
DESCRIPTION:Rappel 15 min avant
END:VALARM
END:VEVENT
END:VCALENDAR`.trim();

      // Create a Blob and trigger it to open
      const blob = new Blob([icsContent], { type: 'text/calendar;charset=utf-8' });
      const url = URL.createObjectURL(blob);

      // Ouvrir le fichier dans un nouvel onglet (uniquement possible pour les fichiers pris en charge par le navigateur)
      window.open(url, '_blank');

      // Libère l'URL
      URL.revokeObjectURL(url);
  };

  return (
      <Button
          onClick={generateICSFileAndOpen}
          sx={{ mt: 1, mb: 3 }}
          variant="contained"
          color="primary"
      >
        Importer dans Outlook
      </Button>
  );
};

  return (
     <Card
      sx={{
        display: 'flex',
        flexDirection: 'column',
        p: 2,
        '& + &': {
          mt: 2
        },
        borderRadius: '16px',
        boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)',
        border: '1px solid #e2e8f0'
      }}
      {...other}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1, width: '100%' }}>
        <Avatar
          sx={{
            bgcolor: 'transparent',
            width: 32,
            height: 32,
            mr: 1.5
          }}
        >
          { (qualification === 'Vente 1 formation' || qualification === 'Vente 2 formation' || qualification === 'Vente 3 formation') && (
          <AttachMoneyIcon style={{ color: '#16B84E' }} />
          ) }
          { qualification === 'Erreur' && (
          <ErrorOutlineIcon style={{ color: '#64748b' }} />
          ) }
          { qualification === 'Rappel' && (
          <PhoneIcon style={{ color: 'orange' }} />
          ) }
          { qualification === 'Souhaite un email' && (
          <MailOutlineIcon style={{ color: 'purple' }} />
          ) }
          { qualification === 'Refus' && (
          <PanToolIcon style={{ color: '#ff5f52' }} />
          ) }
          { qualification === 'Attente' && (
          <HourglassEmptyIcon style={{ color: '#d7b52c' }} />
          ) }
          { qualification === 'Appel entrant' && (
          <PhoneCallbackIcon style={{ color: '#1E90FF' }} />
          ) }
          { qualification === 'Pas répondu' && (
          <PhoneMissedIcon style={{ color: 'black' }} />
          ) }
        </Avatar>
        <Box sx={{ flexGrow: 1 }}>
          <Typography
            color="textPrimary"
            variant="subtitle2"
            sx={{ fontWeight: 700 }}
          >
            {qualification !== 'Ancien commentaire' ? source : ''}
          </Typography>
          <Typography
            sx={{ 
              fontSize: '0.75rem',
              color: (qualification === 'Vente 1 formation' || qualification === 'Vente 2 formation' || qualification === 'Vente 3 formation') ? '#16B84E' : qualification === 'Refus' ? '#ff5f52' : qualification === 'Erreur' ? '#888888' : qualification === 'Rappel' ? 'orange' : qualification === 'Souhaite un email' ? '#9a68af' : qualification === 'Attente' ? '#d7b52c' : qualification === 'Appel entrant' ? '#1E90FF' : qualification === 'Pas répondu' ? '#888888' : 'black',
              fontWeight: 600
            }}
          >
            {`${qualification} ${reason === null ? '' : reason}${recallDate === undefined || recallDate === null ? '' : moment(recallDate).format('DD/MM/YYYY à H:mm')}`}
          </Typography>
        </Box>
        <IconButton
          size="small"
          onClick={() => handleDelete(id)}
          disabled={qualification === 'Ancien commentaire'}
          sx={{ ml: 1 }}
        >
          <DeleteIcon fontSize="small" />
        </IconButton>
      </Box>

      <Box sx={{ pl: 6 }}>
        <Typography fontSize={13} sx={{ color: '#475569', fontWeight: 600 }}>
          {nameFormation1 !== null && nameFormation1 !== undefined ? '1) ' : formation1 !== null && formation1 !== undefined ? '1) ' : ''}
          {nameFormation1 !== undefined ? nameFormation1Transf : formation1 !== null ? formation1Transf : ''}
        </Typography>
        <Typography fontSize={13} sx={{ color: '#475569', fontWeight: 600 }}>
          {nameFormation2 !== null && nameFormation2 !== undefined ? '2) ' : formation2 !== null && formation2 !== undefined ? '2) ' : ''}
          {nameFormation2 !== undefined ? nameFormation2Transf : formation2 !== null ? formation2Transf : ''}
        </Typography>
        <Typography fontSize={13} sx={{ color: '#475569', fontWeight: 600 }}>
          {nameFormation3 !== null && nameFormation3 !== undefined ? '3) ' : formation3 !== null && formation3 !== undefined ? '3) ' : ''}
          {nameFormation3 !== undefined ? nameFormation3Transf : formation3 !== null ? formation3Transf : ''}
        </Typography>
        <Typography fontSize={13} sx={{ color: '#16B84E', fontWeight: 700 }}>
          {nameOfferedFormation !== null && nameOfferedFormation !== undefined ? `Offerte : ${nameOfferedFormationTransf}` : offeredFormation !== null && offeredFormation !== undefined ? `Offerte : ${offeredFormationTransf}` : ''}
        </Typography>
        <Typography
          variant="body2"
          sx={{ 
            mt: 1, 
            lineHeight: 1.5,
            color: '#1e293b'
          }}
        >
          {comment}
        </Typography>
        { qualification === 'Rappel' && (
          <CreateOutlookMeetingButton />
        ) }
      </Box>

      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1 }}>
        <Typography
          color="textSecondary"
          sx={{ fontSize: '0.7rem', fontStyle: 'italic' }}
        >
          {new Date(createdAt).toLocaleDateString('fr-FR', options)}
        </Typography>
      </Box>
    </Card>
  );
};

CustomerCommercialComment.propTypes = {
  createdAt: PropTypes.string.isRequired,
  comment: PropTypes.string.isRequired,
  source: PropTypes.string.isRequired,
  handleDelete: PropTypes.func.isRequired,
  id: PropTypes.number.isRequired,
  qualification: PropTypes.string.isRequired,
  reason: PropTypes.string,
  recallDate: PropTypes.string,
  formation1: PropTypes.string,
  nameFormation1: PropTypes.string,
  formation2: PropTypes.string,
  nameFormation2: PropTypes.string,
  formation3: PropTypes.string,
  nameFormation3: PropTypes.string,
  offeredFormation: PropTypes.string,
  nameOfferedFormation: PropTypes.string
};

export default CustomerCommercialComment;
